/*
 *  I04CALCULGDETACalcul.js
 *
 *  Created by Sébastien Hecart on 2019-05-14 13:52:10 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */
//import { fetchCoeffGDeta, fetchRVitrage } from "@batical/data/src/Queries/BatiQueries";
import i18n from '@batical/i18n'
import { I04CALCULGDETA_State, I04CALCULGDETAItem_State } from '@batical/types/src'
//import { RCoeffGDeta_Type } from '@batical/types/src';

function I04CALCULGDETA_docalcul(state: I04CALCULGDETA_State, isWeb: boolean = false) {
  //let selectedventilation_uuid = fetchGDetaVentilation(ventilation_uuid)
  const { in_surface, in_hspm, facades, plafonds, planchers, vitrages, portes, in_ventil_lambda } = state
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let graph: Array<any> = []
  state.res_volume = in_surface * in_hspm
  //Calcul coeff isole moyen
  let totalU = 0
  let coeffIsoMoyen = 0.0
  let totalUSection = 0
  let coeffIsoSumSurface = 0
  //console.group('==============START I04CALCULGDETA_docalcul =========');

  if (facades) {
    totalUSection = 0
    let totalUPontThermique = 0
    facades.map((item: I04CALCULGDETAItem_State) => {
      //const taux = fetchTauxPositionMurExterieur(item.in_paroi_position)
      let surfaceacade = item.in_superficie

      if (vitrages) {
        vitrages.map((itemVitrage: I04CALCULGDETAItem_State) => {
          if (itemVitrage.vitrage_facade_uuid === item.item_uuid) {
            surfaceacade -= itemVitrage.in_superficie
          }
        })
      }
      //totalUSection
      totalUSection += item.in_ucorr * fetchTauxPositionMurExterieur(item.in_paroi_position) * Math.max(0, surfaceacade)
      coeffIsoMoyen += Math.max(0, surfaceacade) * fetchTauxPontThermique(item.in_iso_position)
      coeffIsoSumSurface += Math.max(0, surfaceacade)
      //in the same time, add the pont thermique
      totalUPontThermique += item.in_ucorr * Math.max(0, surfaceacade)
    })
    if (coeffIsoSumSurface !== 0) {
      coeffIsoMoyen /= coeffIsoSumSurface
    }

    if (totalUSection > 0) {
      if (isWeb) {
        graph.push({
          id: '0',
          label: i18n.t('I04CALCULGDETA_SECTION_1_TITLE'),
          y: totalUSection,
          value: totalUSection,
          color: i18n.t('I04CALCULGDETA_color_facades')
        })
      } else {
        graph.push({
          x: i18n.t('I04CALCULGDETA_SECTION_1_TITLE'),
          y: totalUSection,
          value: totalUSection,
          color: i18n.t('I04CALCULGDETA_color_facades')
        })
      }
    }
    totalU += totalUSection + totalUPontThermique * coeffIsoMoyen
  }

  if (plafonds) {
    totalUSection = 0
    plafonds.map((item: I04CALCULGDETAItem_State) => {
      //const taux = fetchTauxPositionMurExterieur(item.in_paroi_position)
      totalUSection += item.in_ucorr * fetchTauxPositionPlafond(item.in_plafond_position) * Math.max(0, item.in_superficie)
    })
    totalU += totalUSection

    if (totalUSection > 0) {
      if (isWeb) {
        graph.push({
          id: '2',
          label: i18n.t('I04CALCULGDETA_SECTION_2_TITLE'),
          y: totalUSection,
          value: totalUSection,
          color: i18n.t('I04CALCULGDETA_color_plafonds')
        })
      } else {
        graph.push({
          x: i18n.t('I04CALCULGDETA_SECTION_2_TITLE'),
          y: totalUSection,
          value: totalUSection,
          color: i18n.t('I04CALCULGDETA_color_plafonds')
        })
      }
    }
  }

  if (planchers) {
    totalUSection = 0
    planchers.map((item: I04CALCULGDETAItem_State) => {
      totalUSection += item.in_ucorr * fetchTauxPositionPlancher(item.in_plancher_position) * Math.max(0, item.in_superficie)
    })
    totalU += totalUSection

    if (totalUSection > 0) {
      if (isWeb) {
        graph.push({
          id: '3',
          label: i18n.t('I04CALCULGDETA_SECTION_3_TITLE'),
          y: totalUSection,
          value: totalUSection,
          color: i18n.t('I04CALCULGDETA_color_planchers')
        })
      } else {
        graph.push({
          x: i18n.t('I04CALCULGDETA_SECTION_3_TITLE'),
          y: totalUSection,
          value: totalUSection,
          color: i18n.t('I04CALCULGDETA_color_planchers')
        })
      }
    }
  }

  if (portes) {
    totalUSection = 0
    portes.map((item: I04CALCULGDETAItem_State) => {
      //const taux = fetchTauxPositionMurExterieur(item.in_paroi_position)
      totalUSection += item.in_ucorr * Math.max(0, item.in_superficie)
    })
    totalU += totalUSection

    if (totalUSection > 0) {
      if (isWeb) {
        graph.push({
          id: '4',
          label: i18n.t('I04CALCULGDETA_SECTION_5_TITLE'),
          y: totalUSection,
          value: totalUSection,
          color: i18n.t('I04CALCULGDETA_color_portes')
        })
      } else {
        graph.push({
          x: i18n.t('I04CALCULGDETA_SECTION_5_TITLE'),
          y: totalUSection,
          value: totalUSection,
          color: i18n.t('I04CALCULGDETA_color_portes')
        })
      }
    }
  }

  if (vitrages) {
    totalUSection = 0
    vitrages.map((item: I04CALCULGDETAItem_State) => {
      //const taux = fetchTauxPositionMurExterieur(item.in_paroi_position)
      totalUSection += item.in_ucorr * Math.max(0, item.in_superficie)
      // console.group();
      // console.log('vitrages item', item);
      // console.log('tauname:', fetchTauxPositionPlancher(item.in_paroi_position));
      // console.log('Surface vitrages ', item.in_superficie);
      // console.log('Uk for vitrages ', item.in_ucorr  * Math.max(0, item.in_superficie));
      // console.groupEnd();
    })
    totalU += totalUSection

    if (totalUSection > 0) {
      if (isWeb) {
        graph.push({
          id: '5',
          label: i18n.t('I04CALCULGDETA_SECTION_4_TITLE'),
          y: totalUSection,
          value: totalUSection,
          color: i18n.t('I04CALCULGDETA_color_vitrages')
        })
      } else {
        graph.push({
          x: i18n.t('I04CALCULGDETA_SECTION_4_TITLE'),
          y: totalUSection,
          value: totalUSection,
          color: i18n.t('I04CALCULGDETA_color_vitrages')
        })
      }
    }
  }
  if (isWeb) {
    graph.push({
      id: '1',
      label: i18n.t('I04CALCULGDETA_SECTION_8_TITLE'),
      y: totalU * coeffIsoMoyen,
      value: totalU * coeffIsoMoyen,
      color: i18n.t('I04CALCULGDETA_color_pont')
    })
  } else {
    graph.push({
      x: i18n.t('I04CALCULGDETA_SECTION_8_TITLE'),
      y: totalU * coeffIsoMoyen,
      value: totalU * coeffIsoMoyen,
      color: i18n.t('I04CALCULGDETA_color_pont')
    })
  }

  totalUSection = 0.34 * state.res_volume * in_ventil_lambda
  totalU += totalUSection

  if (totalUSection > 0) {
    if (isWeb) {
      graph.push({
        id: '6',
        label: i18n.t('I04CALCULGDETA_SECTION_6_TITLE'),
        y: totalUSection,
        value: totalUSection,
        color: i18n.t('I04CALCULGDETA_color_ventilation')
      })
    } else {
      graph.push({
        x: i18n.t('I04CALCULGDETA_SECTION_6_TITLE'),
        y: totalUSection,
        value: totalUSection,
        color: i18n.t('I04CALCULGDETA_color_ventilation')
      })
    }
  }
  if (state.res_volume !== 0) {
    state.res_coeffG = totalU / state.res_volume
  }
  //console.log('data', graph);
  //console.groupEnd();
  //made a p final to get the % in the graph
  if (totalU !== 0) {
    if (isWeb) {
      state.res_graph = graph.map(item => {
        item.value = Math.trunc((item.y / totalU) * 1000) / 10
        return item
      })
    } else {
      state.res_graph = graph.map(item => {
        item.y = Math.trunc((item.y / totalU) * 1000) / 10
        return item
      })
    }
  } else {
    state.res_graph = null
  }
  state.invalidated = false
  return state
}

//harcoded and ugly as shit because guigeek was funny ...
// Seb, en genral les listes d'afficahge tu créais pas de Database, c pour ca j en ai pas fait.
/// -> mouais t en as fait aucune de toute maniere et la il y a des valeurs donc on aurait du en faire.
/// Du coup j 'ai utilise des segments sans UUID et ca va foutre la merde.
function fetchTauxPositionPlafond(uuid: string): number {
  switch (uuid) {
    case 'pos_plafond_0':
      return 1
    case 'pos_plafond_1':
      return 0.8
    case 'pos_plafond_2':
      return 0.7
    default:
      return 0
  }
}

function fetchTauxPositionMurExterieur(index: number): number {
  switch (index) {
    case 0:
      return 1
    case 1:
      return 0.7
    case 2:
      return 0.5
    default:
      return 0
  }
}

function fetchTauxPositionPlancher(uuid: string): number {
  switch (uuid) {
    case 'pos_plancher_0':
      return 1
    case 'pos_plancher_1':
      return 0.7
    case 'pos_plancher_2':
      return 1
    case 'pos_plancher_3':
      return 0.4
    default:
      return 0
  }
}

function fetchTauxPontThermique(index: number): number {
  switch (index) {
    case 2: //sans isolant ajouter apres
      return 0.0
    case 0:
      return 0.02
    case 1:
      return 0.2
    default:
      return 0
  }
}

export default I04CALCULGDETA_docalcul
